import React from 'react'
import { useTheme } from '../contexts/ThemeContext'
import { Sun, Moon } from './icons'

/**
 * Dark mode toggle.
 *
 * Renders a single icon (sun in dark mode, moon in light mode) that
 * flips theme on click. Theme persists to localStorage via
 * ThemeContext.
 */
export const DarkModeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'

  return (
    <button
      onClick={toggleTheme}
      data-testid="dark-mode-toggle"
      className="h-8 w-8 rounded-md grid place-items-center text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500"
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {isDark ? (
        <Sun className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" />
      ) : (
        <Moon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" />
      )}
    </button>
  )
}
